import { createJSONRequest, createFileRequest } from '../../../api/create-request.js'

const BASE_URL = '/api/legal-policies'

export const fetchAll = (type?: string) => createJSONRequest({
  method: 'GET',
  url: type ? `${BASE_URL}?type=${type}` : BASE_URL,
})

export const create = (formData: FormData) => createFileRequest({
  method: 'POST',
  url: BASE_URL,
  body: formData,
})

export const update = (id: number, formData: FormData) => {
  formData.append('_method', 'PUT')

  return createFileRequest({
    method: 'POST',
    url: `${BASE_URL}/${id}`,
    body: formData,
  })
}

export const remove = (id: number) => createJSONRequest({
  method: 'DELETE',
  url: `${BASE_URL}/${id}`,
})

export const fetchActiveByType = (type: string, id?: number | string) => createJSONRequest({
  method: 'GET',
  url: id ? `${BASE_URL}/${id}/content/${type}` : `${BASE_URL}/active/${type}`,
})

export const updateContentByType = (id: number | string, type: string, markdown: string) => createJSONRequest({
  method: 'PUT',
  url: `${BASE_URL}/${id}/content/${type}`,
  data: { markdown },
})

export const downloadUrl = (id: number, type: string): string =>
  `${BASE_URL}/${id}/download/${type}`
